export function getOS(): OS | null {
  const userAgent = window.navigator.userAgent
  const platform = window.navigator.platform
  const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"]
  const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"]
  const iosPlatforms = ["iPhone", "iPad", "iPod"]
  let os: OS | null = null

  if (macosPlatforms.includes(platform)) {
    os = OS.MacOS
  } else if (iosPlatforms.includes(platform)) {
    os = OS.iOS
  } else if (windowsPlatforms.includes(platform)) {
    os = OS.Windows
  } else if (userAgent.includes("Android")) {
    os = OS.Android
  } else if (os != null && platform.includes("Linux")) {
    os = OS.Linux
  }

  return os
}

export enum OS {
  MacOS,
  iOS,
  Windows,
  Android,
  Linux,
}
